import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.07 4.262c.874-1.456 2.985-1.456 3.86 0l7.85 13.085c.9 1.5-.181 3.407-1.93 3.407H4.15c-1.75 0-2.83-1.907-1.93-3.407zm2.573.772a.75.75 0 0 0-1.287 0l-7.85 13.085a.75.75 0 0 0 .643 1.136H19.85a.75.75 0 0 0 .644-1.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 14.005v-5a.75.75 0 1 1 1.5 0v5a.75.75 0 0 1-1.5 0M13 16.755a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }));
}
var IcError = createNolIcon(/*#__PURE__*/forwardRef(SvgIcError));

export { IcError as I };
